// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3o9Lr"};